import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const untilMidnight = () => {
  const now = new Date();
  const end = new Date(now);
  end.setHours(24, 0, 0, 0);
  return Math.max(0, Math.floor((end - now) / 1000));
};
const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ v, l }) => (
  <span className="inline-flex items-baseline gap-0.5">
    <span className="min-w-[1.6em] rounded-md bg-sun px-1 py-0.5 text-center font-display text-sm font-extrabold tabular-nums text-ink">{pad(v)}</span>
    <span className="text-[11px] text-sun/80">{l}</span>
  </span>
);

export const TopBar = () => {
  const [s, setS] = useState(untilMidnight);
  useEffect(() => {
    const id = setInterval(() => setS(untilMidnight()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 bg-ink px-3 py-2.5 text-white" data-testid="topbar">
      <span className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.15em] text-sun">
        <Timer className="h-4 w-4" /> Oferta de hoje termina em
      </span>
      <span className="flex items-center gap-1.5" data-testid="topbar-countdown">
        <Unit v={Math.floor(s / 3600)} l="h" />
        <Unit v={Math.floor((s % 3600) / 60)} l="m" />
        <Unit v={s % 60} l="s" />
      </span>
    </div>
  );
};
